import { GetReportReviewResponse } from '@lib/types/api/ProductPreview';
import {
  GetReviewResponse,
  ListReviewsResponse,
  UpdateReviewResponse,
} from '@lib/types/api/Review';
import {
  listReviewsResponseWith30ItemsMock,
  updateReviewResponseMock,
} from '@test/mocks/review.mocks';

export const marketplaceReviewResponseMock:
  | UpdateReviewResponse
  | GetReviewResponse = updateReviewResponseMock;

export const marketplaceListReviewsResponseMock: ListReviewsResponse = {
  items: listReviewsResponseWith30ItemsMock.items,
  total: listReviewsResponseWith30ItemsMock.total,
  start: listReviewsResponseWith30ItemsMock.start,
  count: listReviewsResponseWith30ItemsMock.count,
};

export const updateReportReviewResponseMock: GetReportReviewResponse = {
  reason: 'This review contains inappropriate language and false claims',
  type: 'LANGUAGE',
};
